// App.js
import React from 'react';
import {
    Container,
    Grid,
    Typography,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import { Facebook, Twitter, Instagram, LinkedIn, YouTube } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ContactForm from '../forms/contactForm.js';

const DigitalMarketingServices = () => (
    <Card>
        <CardContent>
            <Typography variant="h1"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
                Skyrocket Your Business with Digital Marketing
            </Typography>
            <Typography variant="h3"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
                with our custom tailored Strategies for you!
            </Typography>
            <Typography variant="h6" paragraph>
                Elevate your brand to new heights with our cutting-edge digital marketing
                services. We specialize in creating impactful social media campaigns that
                drive results. Explore the power of social media ads on platforms like
                Facebook <Facebook fontSize="large" color="primary" />, 
                Instagram <Instagram fontSize="large" color="secondary" />, 
                Twitter <i class="fa-solid fa-x"><b>X</b></i>, 
                LinkedIn <LinkedIn fontSize="large" color="primary" />, 
                and YouTube <YouTube fontSize="large" color="error" />.
            </Typography>

            <Typography variant="h6"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
                Types of Social Media Ads:
            </Typography>
            <Typography variant="h6" gutterBottom>
                Social media ads come in various formats to suit your business goals:
            </Typography>
            <ul>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }} >Image ads:</Typography> Simple and eye-catching images that promote
                    your product or service.
                </li>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }}>Video ads:</Typography> Short, engaging videos that can tell a story
                    or showcase your product in action.
                </li>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }}>Carousel ads:</Typography> A series of images or videos that users
                    can swipe through.
                </li>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }}>Story ads:</Typography> Ads that appear in the Stories feature of
                    platforms like Instagram <Instagram fontSize="large" color="secondary" /> and Facebook <Facebook fontSize="large" color="primary" />.
                </li>
            </ul>

            <Typography variant="h6"  style={{ color: "#356D7F", fontWeight: 'bold' }}gutterBottom>
                Benefits of Using Social Media Ads:
            </Typography>
            <ul>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }}>Reach a large audience:</Typography> Social media platforms have
                    billions of users, so you can reach a vast potential customer base.
                </li>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }}>Target your audience:</Typography> You can target your ads to specific
                    demographics, interests, and behaviors, ensuring that your message reaches
                    the right people.
                </li>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }}>Track your results:</Typography> Social media platforms provide detailed
                    analytics that you can use to track the performance of your ads and make
                    adjustments as needed.
                </li>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }}>Increase brand awareness:</Typography> Social media ads can help you
                    build brand awareness and recognition among your target audience.
                </li>
                <li>
                    <Typography variant="h3" style={{ color: "#356D7F" }}>Drive traffic and conversions:</Typography> Use social media ads to drive
                    traffic to your website or landing page, ultimately increasing conversions.
                </li>
            </ul>

            <Typography variant="h6" style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
                Frequently Asked Questions:
            </Typography>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <Typography>What is the importance of social media ads?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Social media ads are crucial for businesses to reach a wider audience,
                        engage with potential customers, and drive conversions. With billions of
                        users on various platforms, social media ads offer unparalleled targeting
                        options and detailed analytics to measure success.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                    <Typography>How do I choose the right social media platform for ads?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        The choice of the platform depends on your target audience and business goals.
                        We'll analyze your objectives and help you select the platforms where your
                        audience is most active and likely to engage with your content.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Typography variant="h3"  style={{ color: "#356D7F", fontWeight: 'bold' }} paragraph>
                Ready to take your business to the next level? 
            </Typography>
            <Typography variant="h3"  style={{ color: "#356D7F", fontWeight: 'bold' }} paragraph>
                Let's connect and create a
                tailored digital marketing strategy that works for you.
            </Typography>
        </CardContent>
    </Card>
);

const DigitalMarketing = () => (
    <Container>
        <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
                <DigitalMarketingServices />
            </Grid>
            <Grid item xs={12} md={4}>
                <ContactForm 
                header = "Ready to Ignite Your Brand? Let's Connect!"
                body = "Fill out the form below, and let's start a conversation about growing your business in the digital era."/>
            </Grid>
        </Grid>
    </Container>
);

export default DigitalMarketing;
